export default __webpack_public_path__ + "static/media/TROUT.167382a1.svg";